/*
 * @Author: Li
 * @Date: 2019-11-28 14:49:58
 * @Descripttion: 
 * @Param: 
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/index.scss' // global css
import echarts from 'echarts'
import moment from 'vue-moment'
import momentc from 'moment/moment'
import axios from "@/utils/request.js"
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
    getToken
} from '@/utils/auth' // getToken from cookie
import "babel-polyfill"
import 'es6-promise/auto'
import PromptMessage from '@/components/PromptMessage/index.vue'


Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.use(moment);

Vue.component('PromptMessage', PromptMessage);

Vue.prototype.$ELEMENT = {
    size: 'small',
    zIndex: 3000
};
Vue.config.productionTip = false;

NProgress.configure({
    showSpinner: false
}) // NProgress configuration
// 
const whiteList = ['/login', '/Register', '/agreement', '/agreementhy'] // 不重定向白名单
router.beforeEach((to, from, next) => {
    NProgress.start()
    if (getToken()) {
        if (to.path === '/loging') {
            next({
                path: '/'
            })
            NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
            next();
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            // var reg = /^newtb.*/;    
            // if(reg.test(location.host)){
            //   location.href = `http://tb.580tequan.com/#/login?redirect=${to.path}`;
            // }else{
            //   next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
            // }

            // 否则全部重定向到登录页
            next(`/login?redirect=${to.path}`)

            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done() // 结束Progress
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>',
    created: function () {
        let url = window.location.href;
        if (url.indexOf("b.maihaoquan") != -1) {
            window.document.documentElement.setAttribute('data-theme', 'primary3');
        }
        if (url.indexOf("bq.maihaoquan") != -1) {
            window.document.documentElement.setAttribute('data-theme', 'primary2');
        }
    }
})


// WEBPACK FOOTER //
// ./src/main.js